/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingResponseDtoPriceType = typeof ListingResponseDtoPriceType[keyof typeof ListingResponseDtoPriceType] | null;


export const ListingResponseDtoPriceType = {
  PER_SQM: 'PER_SQM',
  PER_YEAR: 'PER_YEAR',
  PER_MONTH: 'PER_MONTH',
  PER_SQM_PER_MONTH: 'PER_SQM_PER_MONTH',
  TOTAL: 'TOTAL',
} as const;
